import QuestionController from "../question_controller"

export default class extends QuestionController {

}
